import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const fetchPettyCashCommonRequestCategoryList = createAsyncThunk(
	"fetchPettyCashCommonRequestCategoryList",
	async (_, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`/category/list?categoryType=Petty Cash&page=1&limit=100`);
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const PettyCashCommonRequestCategoryListSlice = createSlice({
	name: "PettyCashCommonRequestCategoryListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashCommonRequestCategoryListState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashCommonRequestCategoryList.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchPettyCashCommonRequestCategoryList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashCommonRequestCategoryList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashCommonRequestCategoryListState } = PettyCashCommonRequestCategoryListSlice.actions;
export default PettyCashCommonRequestCategoryListSlice.reducer;
